var map = {
	"./basic-01.png": 50479,
	"./basic-01_en.png": 88104,
	"./basic-02.png": 91986,
	"./basic-02_en.png": 65376,
	"./basic-03.png": 59940,
	"./basic-03_en.png": 20876,
	"./basic-04.png": 15879,
	"./basic-04_en.png": 4179,
	"./basic-05.png": 50160,
	"./basic-06.png": 58802,
	"./basic-07.png": 23121,
	"./basic-08.png": 1964,
	"./basic-09.png": 67517,
	"./basic-10.png": 23199,
	"./basic-bg-01.png": 13525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26798;